import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import TiledMenuHeader from 'components/tiled-menu/Header'
import { setLegislationKeyword, setLegislationShowFavouritesOnly, setLegislationSelectedAols } from 'redux/actions'

export default function LegislationFoldersHeader () {
  const dispatch = useDispatch()
  const keyword = useSelector(state => state.legislation.keyword || '')
  const showFavouritesOnly = useSelector(state => state.legislation.showFavouritesOnly || false)
  const selectedAols = useSelector(state => state.legislation.selectedAols || [])

  const setKeyword = (val) => {
    dispatch(setLegislationKeyword(val))
  }

  const setShowFavouritesOnly = (newValue) => {
    dispatch(setLegislationShowFavouritesOnly(newValue))
  }

  const setSelectedAols = (aols) => {
    dispatch(setLegislationSelectedAols(aols))
  }

  return (
    <TiledMenuHeader
      title='Legislation'
      showSelectAols
      keyword={keyword}
      setKeyword={setKeyword}
      showFavouritesOnly={showFavouritesOnly}
      setShowFavouritesOnly={setShowFavouritesOnly}
      selectedAols={selectedAols}
      setSelectedAols={setSelectedAols}
    />
  )
}
